import getConfig from 'next/config';

const WHITE_THEME = 'white';
const BLUE_THEME = 'blue';

const {
  publicRuntimeConfig: { themeName },
} = getConfig();

export interface OptionsType<T> {
  [WHITE_THEME]: T;
  [BLUE_THEME]: T;
}

export function themeSelector<T>(options: OptionsType<T>): T {
  //@ts-ignore
  return options?.[themeName] ?? options['blue'];
}
